/* 呼び出し画面区分 */
export default {
    // マイページ画面
    MYPAGE: "1",
    // 予約画面
    RESERVATION: "2"
}